module.exports = __webpack_public_path__ + "img/resul_four_day_march_logo_transbg_2022_old.fda547b7.png";